import { ISeasonRankingPageProps } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidSeasonRankingPage } from './typeguards';
import { SeasonRankingGalleryQuery } from '../types';
import { CreateSeasonRankingGalleryWidgetInputSchema, SeasonDriverRanking, SeasonTeamRanking } from 'cdk/graphql';
import { WidgetError, ErrorName } from '../../../utils/errors';
import {advsMapping} from '../../../utils/adv';
import { slugify } from "@sky-it-livedata-libraries/livedata-commons";
import { intcmpMap } from '../../../utils/intcmp';

export default (obj: SeasonRankingGalleryQuery): ISeasonRankingPageProps => {
  if (isValidSeasonRankingPage(obj)) {
    CreateSeasonRankingGalleryWidgetInputSchema().parse(obj.data.getSeasonRankingGalleryWidget, {reportInput: true});
      const { drivers, teams, competitionsSlugName, competitionName  } = obj.data.getSeasonRankingGalleryWidget;

      const transformedDrivers = drivers?.map(driverObject => {

        const driver = driverObject as SeasonDriverRanking;
        
        const { driverFirstname, driverImageUrl, driverPageLink, driverSurname, ...rest } = driver;

        return {
          ...rest,
          firstName: driver.driverFirstname,
          imageUrl: driver.driverImageUrl,
          url: driver.driverPageLink,
          lastName: driver.driverSurname,
          seoTeamName: slugify(driver.teamName || ''),
        }
      });

      const transformedTeams = teams?.map(teamObject => {

        const team = teamObject as SeasonTeamRanking;

        const {teamImageUrl, teamUrl, ...rest} = team;

        return {
          ...rest,
          imageUrl: team.teamImageUrl,
          url: team.teamUrl,
          seoTeamName: slugify(team.teamName || ''),
        }
      })

      return {
        competitionName: competitionName as ISeasonRankingPageProps['competitionName'],
        competitionSlugName: competitionsSlugName as ISeasonRankingPageProps['competitionSlugName'],
        advBoxAttributes: advsMapping['season-ranking-gallery'],
        drivers: transformedDrivers as ISeasonRankingPageProps['drivers'],
        teams: transformedTeams as ISeasonRankingPageProps['teams'],
        trackingData: {
          intCmpTabDrivers: intcmpMap.seasonRankingGallery.tabDrivers,
          intCmpTabTeams: intcmpMap.seasonRankingGallery.tabTeams,
          intCmpCardFull: intcmpMap.seasonRankingGallery.cardFull,
          intCmpCardLogo: intcmpMap.seasonRankingGallery.cardLogo,
        }
      };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in SeasonRankingGalleryQuery object',
      data: obj
    });
  }
};
